import { useDevice } from 'components/DeviceContext.js';
import logoCNM from 'Imagens/logo-cnm-rodape.png';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EmailIcon from '@mui/icons-material/Email';
import { Grid } from "@material-ui/core";

const InformacoesCNM = () => {
    const { isMobile } = useDevice();
    return (
        <Grid container style={{ backgroundColor: 'var(--azul-home)', justifyContent: 'center', alignItems: 'center', color: 'var(--branco)', minHeight: '18vh', display: 'flex', flexDirection: isMobile ? 'column' : '', paddingTop: '1em' }}>
            <Grid item md={2}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5em' }}>
                    <a href="https://m.facebook.com/portalcnm/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'var(--branco)' }}>
                        <FacebookIcon style={{ marginRight: '0.5em' }} /> /PortalCNM
                    </a>
                    <a href='https://x.com/portalcnm' target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'var(--branco)' }}>
                        <XIcon style={{ marginRight: '0.5em' }} /> @portalcnm
                    </a>
                    <a href='https://www.youtube.com/user/tvportalcnm' target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'var(--branco)' }}>
                        <YouTubeIcon style={{ marginRight: '0.5em' }} /> /TVPortalCNM
                    </a>
                </div>
            </Grid>
            <Grid item md={2}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5em' }}>
                    <a href='https://www.instagram.com/portalcnm/' target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'var(--branco)' }}>
                        <InstagramIcon style={{ marginRight: '0.5em' }} /> /PortalCNM
                    </a>
                    <a href='https://app.cnm.org.br' target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'var(--branco)' }}>
                        <PhoneIphoneIcon style={{ marginRight: '0.5em' }} /> app.cnm.org.br
                    </a>
                </div>
            </Grid>
            <Grid item md={2}>
                <p>
                    SGAN 601 Módulo N <br />
                    Brasília/DF | CEP: 70.830-010
                </p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                    <EmailIcon style={{ marginRight: '0.5em' }} /> gabinete@cnm.org.br
                </p>
            </Grid>
            <Grid item md={2}>
                <p>
                    <img style={{ width: '200px' }} src={logoCNM} alt="CNM Logo" />
                </p>
            </Grid>
        </Grid>
    );
}

export default InformacoesCNM;
